import { render, staticRenderFns } from "./BalancoLista.vue?vue&type=template&id=2a4e473e&scoped=true&"
import script from "./BalancoLista.vue?vue&type=script&lang=js&"
export * from "./BalancoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e473e",
  null
  
)

export default component.exports